import React, { useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { Header } from '@features/header/Header';
import { useAuthStore } from 'src/store/auth';
import { useGeneralStore } from 'src/store';
import { useIsW2Host } from '@features/w2/host/w2Host';
import { AnimatedDots } from '@components/shared/animated-dots/AnimatedDots';
import { cn } from '@utils/index';
import { LayoutProvider, useLayout } from './LayoutContext';
import { LayoutLoading } from 'src/layouts/LayoutLoading';



interface PublicLayoutProps {
  mainClassName?: string;
}

const PublicLayoutContent: React.FC<PublicLayoutProps> = ({
  mainClassName: propMainClassName,
}) => {
  const { isAuthenticated } = useAuthStore();
  const isLoadingConfig = useGeneralStore((s) => s.isLoadingConfig);
  const isW2Host = useIsW2Host();
  const { mainClassName: contextMainClassName } = useLayout();

  useEffect(() => {}, [isAuthenticated]);

  if (isAuthenticated) {
    // Hold the redirect until the brand/group has resolved: while the config is
    // still loading `useIsW2Host()` reads false, so redirecting now could bounce
    // a W2 employee to `/form` — which the W2 host gate then blocks. Once
    // resolved, W2 hosts go to `/select-plans`; B2C hosts keep the `/form` redirect.
    if (isLoadingConfig) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#F6F1E9]">
          <AnimatedDots />
        </div>
      );
    }
    return <Navigate to={isW2Host ? '/select-plans' : '/form'} replace />;
  }

  const finalMainClassName = propMainClassName || contextMainClassName;

  return (
    <div className="flex flex-col min-h-screen pt-5 pb-6 gap-6">
      <LayoutLoading />
      <Header />
      <main
        className={cn(
          'flex justify-between rounded-xl w-full max-w-[1920px] mx-auto px-6 min-h-[calc(100vh-156px)]',
          finalMainClassName
        )}
      >
        <div className="w-full">
          <Outlet />
        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export const PublicLayout: React.FC<PublicLayoutProps> = (props) => {
  return (
    <LayoutProvider>
      <PublicLayoutContent {...props} />
    </LayoutProvider>
  );
};
